"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSuccess = exports.handleError = void 0;
var handleSuccess = function handleSuccess(response) {
  var status = response.status,
    res = response.data;
  if (status >= 400) {
    var error = new Error("Request failed with status code ".concat(status || 'UNKNOWN'));
    error.response = response;
    return Promise.resolve(error);
  }
  if (res.code !== 0) {
    var _error = new Error(res.msg || "Request failed with data code ".concat(res.code || 'UNKNOWN')); // @ts-ignore

    _error.response = response;
    return Promise.resolve(_error);
  }
  return Promise.resolve(res);
};
exports.handleSuccess = handleSuccess;
var handleError = function handleError(err) {
  return Promise.resolve(err);
};
exports.handleError = handleError;